import { render } from "./cell_date.vue?vue&type=template&id=1fad12fd"
import script from "./cell_date.vue?vue&type=script&lang=ts"
export * from "./cell_date.vue?vue&type=script&lang=ts"
script.render = render

export default script